import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// img imports

import img1 from "../Assets/Images/result_img1.png";
import img2 from "../Assets/Images/result_img2.png";
import img3 from "../Assets/Images/result_img3.png";
import img4 from "../Assets/Images/result_img4.png";
import img5 from "../Assets/Images/result_img5.png";

const Result_main = () => {

    const cardImages = [
        img1,
        img2,
        img3,
        img4,
        img5
    ];

    return (
      <div className="result_sec">
        <Container>
            <Row className="result_row">

                <Col lg={12}>
                 <div className="result_heading">
                    <h5>✨ Real Stories. Visible Results. ✨</h5>
                    <p>From dull to glowing – see how Ayurveda transforms lives naturally.</p>
                 </div>
                </Col>
               
               {cardImages.map((img, index) => (
                    <Col lg={2} sm={6} md={4} key={index}>
                    <div className="result_card">
                        <img src={img} alt="" className="img-fluid" />
                    </div>
                    </Col>
                ))}

                <Col lg={12}>
                 <div className="result_btn">
                   <a href="product" className="btn-main">Shop Now</a>
                 </div>
                </Col>

            </Row>
        </Container>
      </div>
    );
};
export default Result_main;
